export const ThreeVerticalDotsIcon = ({
  width = '4',
  height = '17',
}: {
  width?: string;
  height?: string;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 4 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 8.125C0 9.15875 0.84125 10 1.875 10C2.90875 10 3.75 9.15875 3.75 8.125C3.75 7.09125 2.90875 6.25 1.875 6.25C0.84125 6.25 0 7.09125 0 8.125Z"
        fill="black"
      />
      <path
        d="M0 14.375C0 15.4088 0.84125 16.25 1.875 16.25C2.90875 16.25 3.75 15.4088 3.75 14.375C3.75 13.3412 2.90875 12.5 1.875 12.5C0.84125 12.5 0 13.3412 0 14.375Z"
        fill="black"
      />
      <path
        d="M0 1.875C0 2.90875 0.84125 3.75 1.875 3.75C2.90875 3.75 3.75 2.90875 3.75 1.875C3.75 0.84125 2.90875 0 1.875 0C0.84125 0 0 0.84125 0 1.875Z"
        fill="black"
      />
    </svg>
  );
};
